import { styleSheetReplaceImport } from "./omni-util.js";
import { stylesheet } from "./stylesheet.js";
const omniStyleSheets = [];
let omniStandardStyleSheet;
try {
  omniStandardStyleSheet = new CSSStyleSheet();
} catch (e) {
  console.error(
    `Omni UI: missing Constructable Style Sheets polyfill for Safari and Firefox. See https://www.npmjs.com/package/construct-style-sheets-polyfill`
  );
  throw e;
}
styleSheetReplaceImport(omniStandardStyleSheet, stylesheet).catch((e) => console.error(`omniStyleSheets error (${e})`));
omniStyleSheets.push(omniStandardStyleSheet);
export {
  omniStyleSheets
};
//# sourceMappingURL=omni-stylesheets.js.map
